
function initialState() {
  return {
    show: false,
    state: Math.floor(Math.random() * 1000),
    form: {
      surface_built_range: [0, 250],
      price_range: [0, 2000000],
      type: 0,
      rooms: [],
      type: [],
    },
  };
}

export default {
  data() {
    return initialState();
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    reinit() {
      Object.assign(this.$data, initialState());
      this.show = true;
    },
    filter() {
      this.$emit('input', this.form);
      this.$emit('update-filters');
      this.show = false;
    },
  },
};
